import "core-js/actual/promise";
import { cloneDeep } from "lodash-es";
import { DateTime } from "luxon";
import tippy from "tippy.js";
import { Calendar, CalendarOptions, EventClickArg, EventApi, EventMountArg, EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { calEvent, eventCache, eventArray, wrapperOptions } from "./ts/d/calendar";

export default class CalendarWrap {
    el: HTMLElement;
    now: Date;
    eventsCache: eventCache;
    calendars: object
    //ui: object;
    //metadata: string | object;
    options: wrapperOptions;
    defaults: object;
    cal: Calendar | null;

    constructor(element: any, options: any) {
        this.el = element;
        this.cal = null
        this.now = new Date();
        this.eventsCache = {};
        this.calendars = {};
        //this.ui = {};
        this.defaults = {
            categories: {},
            fullcalendar: {
                plugins: [timeGridPlugin, dayGridPlugin],
                initialView: "dayGridMonth",
                businessHours: {
                    daysOfWeek: [1, 2, 3, 4, 5],
                    startTime: '08:00',
                    endTime: '17:00'
                },
                scrollTime: '08:00:00',
                headerToolbar: {
                    start: 'prev,next today',
                    center: 'title',
                    end: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                slotDuration: '00:30:00',
                themeSystem: 'standard'
            },
            onReady: function () { },
            recurringPathArray: [],
            yyyyMMPathMap: {}
        };

        //Available Metadata
        // this.metadata = this.el.dataset.hhCalendarOptions;
        // if (typeof this.metadata === 'string') {
        //     this.metadata = {};
        // }

        this.options = {
            ...this.defaults,
            ...cloneDeep(options),
            //...cloneDeep(this.metadata)
        };

        //What do i do with this? Replace Jquery UI dependency?
        /* this.ui.hasActiveEventPopover = false;
         this.ui.eventPopover = $("<a></a>").css({
             "position": "absolute",
             "zindex": "9999"
         }).appendTo("body"); */

        this.init();

        return this;

        //  this.initPubSub();

    }

    init() {
        var self = this,
            tempDate = self.now,
            fcOptions: CalendarOptions = {
                eventDidMount(args: EventMountArg) {
                    // if (event.target) {
                    //     element.setAttribute("target", "_parent");
                    // }
                    console.log("event did mount");
                },
                // eventClick(info: EventClickArg) {
                //     var popoverContent = "",
                //         whenString = '',
                //         start = info.event.start !== null ? DateTime.fromJSDate(info.event.start) : null,
                //         end = info.event.end !== null ? DateTime.fromJSDate(info.event.end) : null;

                //     // Remove the click event and stop propogation (used for the click outside to close functionality).
                //     info.jsEvent.preventDefault();
                //     info.jsEvent.stopPropagation();

                //     //position of popover --- need to figure out how we are driving the popovers
                //     // self.ui.eventPopover.style.top = e.pageY;
                //     // self.ui.eventPopover.style.left = e.pageX;


                //     /* port over other popover data*/



                //     if (info.event.allDay) {
                //         whenString = start.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
                //         if (end !== null) {
                //             whenString += (end.hasSame(start, 'day')) ? "" : ' - ' + end.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
                //         }
                //     } else {
                //         whenString = start.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY) + ' , '
                //             + start.toLocaleString(DateTime.TIME_SIMPLE) + ' - ';

                //         if (end !== null) {
                //             let fullend = end.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY) + end.toLocaleString(DateTime.TIME_SIMPLE);
                //             whenString += (end.hasSame(start, 'day') ? end.toLocaleString(DateTime.TIME_SIMPLE) : fullend);
                //         }
                //     }

                //     //Generate Popover
                //     popoverContent = '<ul class="unstyled">' +
                //         '<li><strong>When:</strong> <span class="event-date">' + whenString + '</span></li>' +
                //         (info.event.extendedProps.location && '<li><strong>Where:</strong> ' + info.event.extendedProps.location + '</li>' || '') +
                //         (info.event.extendedProps.summary && '<li>' + info.event.extendedProps.summary + '</li>' || '') +
                //         '</ul>' +
                //         '<p class="pull-right"><a href="' + info.event.url + '"' + (info.event.extendedProps.target ? ' target="_parent"' : '') + '>view event <i class="icon-double-angle-right"></i></a></p>';

                //     //Initialize popover (remove bootstrap/jquery dependency? Sub library?)
                //     /*   self.ui.eventPopover.popover({ 
                //            title: event.title + '<a class="close" data-dismiss="popover" style="line-height:14px">×</a>',
                //            content: popoverContent,
                //            trigger: 'manual',
                //            placement: 'top',
                //            html: true
                //        }).popover('show');}) */

                //     //self.ui.hasActiveEventPopover = true;


                // },
                datesSet(args) {
                    console.log("datesSet hook");
                    self.preserveCategories();
                },
                viewDidMount(args) {
                    var currentViewYear = args.view.currentStart.getFullYear();
                    console.log('Running viewDidMount');
                    

                    if (currentViewYear != tempDate.getFullYear()) {
                        //self.cal.render();
                        tempDate.setFullYear(currentViewYear);
                    }
                },
                ...this.options.fullcalendar
            };

        //Initialize Fullcalendar
        this.cal = new Calendar(this.el, fcOptions);
        console.log("Initialize FullCalendar:")
        console.log(this.cal);
        this.cal.render();
        console.log("Render Calendar");
       



        //popover hide on click - this may not be necessary with tippy framework?

        //add single events source.            
        this.cal.addEventSource((info, successCallback, failureCallback) => {
            console.log('Running add event source function');
            let startMonth = 1,
                startYear = info.start.getFullYear(),
                endYear = info.end.getFullYear(),
                endMonth = info.end.getMonth() + 1,
                eventsArray: EventInput[] = [],
                //    monthArray: any = null,
                promiseArray: Array<Promise<EventInput[]>> = [];

            let count = 1;
            while (startYear < endYear + 1 || (startMonth <= endMonth && startYear === endYear)) {
                let key = startYear + (startMonth < 10 ? "0" : "") + startMonth,
                    url = self.options.yyyyMMPathMap[parseInt(key)] || "";

                let tempMonthArray = self.eventsCache[key] || null;

                // console.log("Loop " + count + ": " + key);
                // console.log(url);
                count++
                // console.log("Value of array either from cache or null");
                // console.log(tempMonthArray);
                let promise: Promise<EventInput[]>


                promise = new Promise((resolve, reject) => {

                    if (tempMonthArray === null) {
                        // console.log("Month is null!")
                        if (url !== "") {

                            // console.log("Making HTTP Request");
                            let req = new XMLHttpRequest();
                            req.addEventListener("load", function () {
                                console.log("Response recieved from server");
                                tempMonthArray = [];

                                let response = this.response as XMLDocument

                                response.querySelectorAll("event").forEach((el) => {
                                    let categories: Array<string> = [],
                                    eventUrl: string = "",
                                    isAllDay: boolean;

                                    
                                    let pathNode = el.querySelector("path") as Element;
                                    let alldayNode = el.querySelector("allday") as Element;
                                    if (pathNode.textContent !== null) {
                                        eventUrl = pathNode.textContent.trim()
                                    } else {
                                        throw new Error('Path is null');
                                    };
                                    if (alldayNode.textContent !== null) {
                                        isAllDay = alldayNode.textContent.trim() === 'true';
                                    } else {
                                        throw new Error(`Allday value is null`)
                                    }
                                    
                                    let frequency = el.querySelector("frequency") as Element;
                                    if (frequency.textContent && frequency.textContent !== "Once") {
                                        return true;
                                    }

                                    let category = el.querySelectorAll("category")
                                    category.forEach((c: Element) => {
                                        let cat: string = ""
                                        if (c.textContent) {
                                            cat = c.textContent.trim();
                                        } else {
                                            throw new Error('category is null')
                                        }
        
                                        let className: string | boolean = self._getCategoryCSSClass(cat);

                                        if (className && categories.includes(className) === false) {
                                            categories.push(className);
                                        }
                                    })

                                    if (categories.length > 0) {
                                        categories.reverse();

                                        if (isAllDay !== true) {
                                            categories.push("fixedtime");
                                        }

                                        let idEl = el.querySelector("id") as Element
                                        let titleEl = el.querySelector("title") as Element
                                        let summaryEl = el.querySelector("summary") as Element
                                        let locationEl = el.querySelector("location") as Element
                                        let startISOEl = el.querySelector("startISO") as Element
                                        let endISOEl = el.querySelector("endISO") as Element 
                                        let endEl = el.querySelector("end") as Element
                                        let targetEl = el.querySelector("target") as Element

                                        let end: string | number | undefined;
                                        if (isAllDay && endISOEl.textContent !== startISOEl.textContent) {  
                                            // patching full calendar exclusive end behavior
                                            if (!endEl.textContent) {
                                                throw new Error('No timestamp on item')
                                            }
                                            let tempDate = new Date(parseInt(endEl.textContent));
                                            let result = tempDate.setDate(tempDate.getDate() + 1);
                                            tempDate = new Date(result);
                                            
                                            end = tempDate.getTime()
                                        
                                        } else {
                                            end = endISOEl.textContent ? endISOEl.textContent : undefined;
                                        }

                                        let event: EventInput = {
                                            id: idEl.textContent ? idEl.textContent : undefined,
                                            title: titleEl.textContent ? titleEl.textContent: undefined,
                                            summary: summaryEl.textContent ? summaryEl.textContent : undefined,
                                            location: locationEl.textContent ? locationEl.textContent : undefined,
                                            start: startISOEl.textContent ? startISOEl.textContent : undefined,
                                            end: end,
                                            target: targetEl.textContent ? targetEl.textContent: undefined,
                                            url: eventUrl,
                                            allDay: isAllDay,
                                            className: categories
                                        }

                                        tempMonthArray.push(event)
                                    }



                                })
                                // console.log("Array result from HTTP request")
                                // console.log(tempMonthArray)
                                self.eventsCache[key] = tempMonthArray;
                                // console.log("eventsCache");
                                // console.log(self.eventsCache);
                                resolve(tempMonthArray);

                            });
                            req.responseType = "document"
                            req.open("GET", url.replace(/\&amp\;/g, "&"), true);
                            req.send();
                            // console.log("HTTP Request Sent");

                        }
                    } else {
                        // console.log("not null?")
                        // console.log(tempMonthArray)
                        resolve(tempMonthArray)

                    }

                });

                promiseArray.push(promise);

                startMonth++;
                // console.log("Raw start month: " + startMonth);
                startYear = startYear + Math.floor(startMonth / 13);
                startMonth = startMonth % 13;
                // console.log("start month after modulo: " + startMonth);
                if (startMonth === 0) { startMonth = 1 };
            }
            // console.log("PROMISES");
            // console.log(promiseArray);
            Promise.all(promiseArray).then((values) => {
                values.forEach((array) => {
                    eventsArray = eventsArray.concat(array);
                })
                return eventsArray;
            }).then((events) => {
                successCallback(events);
            });
        });
        // console.log(this.eventsCache);

        //Add recurring events source
        this.cal.addEventSource((info, successCallback, failureCallback) => {
            let i = 0,
                currentDate = new Date(),
                recurringEventsArray = self.eventsCache["recurringEvents"],
                daysMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

            let recurringPromise: Promise<Array<any>>;

            function isValidDay(value: string): value is keyof typeof daysMap {
                return value in daysMap
            }
            function addEventToArray(e: EventInput, start: string, end: string, array: EventInput[]) {
                array.push({
                    id: e.id,
                    title: e.title,
                    summary: e.summary,
                    location: e.location,
                    url: e.url,
                    start: start,
                    end: end,
                    target: e.target,
                    allDay: e.allDay,
                    className: e.className
                })
            }
            //let theData = 
            //theDate = LUXON CALL
            let promiseArray: Array<typeof recurringPromise> = [];

            if (recurringEventsArray === null || recurringEventsArray === undefined || recurringEventsArray.length <= 0) {
                recurringEventsArray = [];
                for (; i < self.options.recurringPathArray.length; i++) {
                    var url = self.options.recurringPathArray[i];
                    if (url !== null && url !== undefined) {
                        recurringPromise = new Promise((resolve, reject) => {
                            let tempArray: Array<EventInput> = [];
                            url = url.replace(/\&amp\;/g, "&");
                            let req = new XMLHttpRequest();
                            req.addEventListener("load", function () {
                                this.response.querySelectorAll("event").forEach((el: any) => {
                                    let categories: Array<string> = [],
                                        frequency = el.querySelector("frequency").textContent;
                                        

                                    if (frequency === "Once") {
                                        return true;
                                    }

                                    let interval = parseInt(el.querySelector("interval").textContent);

                                    el.querySelectorAll("category").forEach((c: Element) => {
                                        
                                        if (!c.textContent) {
                                            throw new Error ("Category is null");
                                        }

                                        let cat = c.textContent;
                                        let className: string | boolean = self._getCategoryCSSClass(cat);

                                        if (className && categories.includes(className) === false) {
                                            categories.push(className);
                                        }
                                    });

                                    if (categories.length > 0) {
                                        categories.reverse();

                                        let isAllDay = el.querySelector("allday").textContent.trim() === 'true'

                                        let reEvent = {
                                            id: el.querySelector("id").textContent,
                                            title: el.querySelector("title").textContent,
                                            summary: el.querySelector("summary").textContent,
                                            location: el.querySelector("location").textContent,
                                            url: url,
                                            start: "",
                                            end: "",
                                            target: (el.querySelector("target").textContent.trim() === 'true'),
                                            allDay: isAllDay,
                                            className: categories
                                        },
                                            mStart = DateTime.fromISO(el.querySelector("startISO").textContent),
                                            mEnd = DateTime.fromISO(el.querySelector("endISO").textContent),
                                            mUntil = DateTime.fromISO(el.querySelector("untilISO").textContent),
                                            mDiff = mEnd.diff(mStart, "seconds"),
                                            _mStart = cloneDeep(mStart);


                                        if (isAllDay !== true) {
                                            reEvent.className.push("fixedtime");
                                        }

                                        // If no until date was provided, default to 2 years out from the starting date.
                                        if (mUntil.isValid === false) {
                                            mUntil = mStart.plus({ years: 2 });
                                        } else {
                                            // Cap the until date to 2 years out from the current year for repeating events.
                                            if (mUntil.diff(mStart, "years").as("years") > 2) {
                                                mUntil = mUntil.set({ year: mStart.year + 2 });
                                            }
                                        }

                                        switch (frequency) {
                                            case 'Daily':
                                                // Add an occurrence for each day+interval.
                                                while (mUntil.diff(mStart, "seconds").as("seconds") >= 0) {
                                                    addEventToArray(reEvent, mStart.toString(), mEnd.toString(), tempArray);

                                                    // Increment the start date based chosen interval.
                                                    mStart = mStart.plus({ days: interval });
                                                    mEnd = mEnd.plus({ days: interval });
                                                }
                                                break;
                                            case 'Weekly':
                                                let days = el.querySelectorAll("day");
                                                // Are we adding a single weekly occurrence, or multiple?
                                                if (days.length < 1) {
                                                    while (mUntil.diff(mStart, "seconds").as("seconds") >= 0) {
                                                        addEventToArray(reEvent, mStart.toString(), mEnd.toString(), tempArray);

                                                        mStart = mStart.plus({ weeks: interval });
                                                        mEnd = mEnd.plus({ weeks: interval });
                                                    }
                                                } else {
                                                    while (mUntil.diff(mStart, "seconds").as("seconds") >= 0) {
                                                        // Loop through each chosen day and add the occurrences.
                                                        days.forEach(function (e: HTMLElement) {
                                                            if (!e.textContent) {
                                                                throw new Error ("invalid Day");
                                                            }
                                                            if (!isValidDay(e.textContent)) {
                                                                throw new Error('invalid Day');
                                                            }
                                                            let newStart = mStart.set({ day: mStart.get("day") + (daysMap[e.textContent] - mStart.get("weekday")) });
                                                            mEnd = mStart.plus(mDiff);

                                                            // Only add occurrences that are after the actual start date.
                                                            if (newStart.diff(mStart, "seconds").as("seconds") >= 0) {
                                                                addEventToArray(reEvent, newStart.toString(), mEnd.toString(), tempArray);
                                                            }
                                                        });

                                                        // Increment the start date based chosen interval.
                                                        mStart = mStart.plus({ week: interval });
                                                        mEnd = mEnd.plus({ week: interval });
                                                    }
                                                }
                                                break;
                                            case 'Monthly':
                                                let dayOfMonthOption = el.querySelectorAll("monthly-day").textContent;
                                                if (dayOfMonthOption == 'day of the month') {
                                                    // Add a monthly occurrence based on the original event's date.
                                                    while (mUntil.diff(mStart, "seconds").as("seconds") >= 0) {
                                                        // Ensure the date exists within the current month.
                                                        if (mStart.get("day") == _mStart.get("day")) {
                                                            addEventToArray(reEvent, mStart.toString(), mEnd.toString(), tempArray);
                                                        }

                                                        // Increment the start date based chosen interval.
                                                        mStart = mStart.plus({ month: interval });
                                                        if (mStart.daysInMonth >= _mStart.get("day")) {
                                                            mStart.set({ day: _mStart.get("day") });
                                                        }
                                                        mEnd = mStart.plus(mDiff);
                                                    }
                                                } else {
                                                    // Add a monthly occurrence based on the original event's day of the week.
                                                    // Determine the position of this day in the month (ie 1st, 2nd ...)
                                                    var theWeek = Math.floor(mStart.get("day") / 7),
                                                        theDay = mStart.get("day") + 1,
                                                        tempMonth = mStart.get("month");
                                                    while (mUntil.diff(mStart, "seconds").as("seconds") >= 0) {
                                                        // If we didn't roll over into the next month, add the event.
                                                        if (tempMonth === mStart.get("month")) {
                                                            addEventToArray(reEvent, mStart.toString(), mEnd.toString(), tempArray);
                                                        }

                                                        // Figure out where the next month's first day lies and add the difference
                                                        // in days with the weekly position.
                                                        mStart = mStart.plus({ month: interval }).set({ day: 1 });
                                                        tempMonth = mStart.get("month");
                                                        if (theDay <= mStart.get("day")) {
                                                            mStart = mStart.set({ day: theDay - mStart.get("day") + ((theWeek + 1) * 7) });
                                                        } else {
                                                            mStart = mStart.set({ day: (theDay - mStart.get("day") + (theWeek * 7)) });
                                                        }

                                                        mEnd = mStart.plus(mDiff);
                                                    }
                                                }
                                                break;
                                            case 'Yearly':
                                                // Add an occurrence for each day+interval.
                                                while (mUntil.diff(mStart, "seconds").as("seconds") >= 0) {
                                                    addEventToArray(reEvent, mStart.toString(), mEnd.toString(), tempArray);

                                                    // Increment the start year based chosen interval.
                                                    mStart = mStart.plus({ year: interval });
                                                    mEnd = mEnd.plus({ year: interval });
                                                }
                                                break;
                                        }
                                    }
                                    // If the event is not all day, add an additional CSS class to revert the color scheme of the event.
                                });
                                resolve(tempArray);
                            });
                            req.responseType = "document"
                            req.open("GET", url.replace(/\&amp\;/g, "&"), true);
                            req.send();
                        });
                        promiseArray.push(recurringPromise);
                    }
                }
            }
            Promise.all(promiseArray).then((values) => {
                values.forEach((array) => {
                    recurringEventsArray = recurringEventsArray.concat(array);
                })
                return recurringEventsArray;
            }).then((events) => {
                if (events.length > 0) {
                    self.eventsCache["recurringEvents"] = events;
                }
                successCallback(events);
            });
        });
    };

    _getCategoryCSSClass(c: string) {
        return this.options.categories[c.replace(/\s/g, "_")] || false;
    };
    toggleOff(event: EventApi, className: string) {
    
    }
    preserveCategories() {
        console.log("PRESERVE CATEGORIES")
        document.querySelectorAll("#calendars a").forEach(function (a) {
            console.log(a)
            if (a === null) {
                throw new Error("ID object is null");
            }
            let idAttr = a.getAttribute("id");
            if (!idAttr) {
                throw new Error("ID attribute is null");
            }
            let elmClass = idAttr.replace("trigger-", ""),
                isOff = a.classList.contains("off"),
                events = document.querySelectorAll("." + elmClass);
                
            console.log(elmClass)
            console.log(isOff)
            console.log(events)
            if (isOff) {
                events.forEach((e)=>{
                    console.log(e)
                    e.classList.add(elmClass + "-off");
                    e.classList.remove(elmClass);

                })
                //events.classList.add("hidden");
            }
        });
    };

    toggleEventsinCategory(category: string, showOrHide: boolean) {
        showOrHide = showOrHide || false;
        //var self = this,
        let events = document.querySelectorAll("." +  category + (showOrHide ? "-off" : ""));

        if (showOrHide) {
          events.forEach((e) => e.classList.add(category));
          events.forEach((e) => e.classList.remove(category+"-off"))
        //  events.forEach((e) => e.classList.toggle('hidden'));
        } else {
          events.forEach((e) => e.classList.add(category+"-off"));
          events.forEach((e) => e.classList.remove(category));
         // events.forEach((e) => e.classList.toggle('hidden'));
        }
    }

    setCategoryColors() {};



    renderCategoryOptions(calendarsDiv: HTMLElement) {
        let htmlString = "";
        let self = this;
        htmlString += "<ul class='unstyled'>";

        for (const [key, value] of Object.entries(this.options.categories)) {
            htmlString += '<li><a id="trigger-' + value + '" href="#"> <span> </span>' + key.replace(/_/g, " ") + '</a></li>';
        }

        htmlString += "</ul>";

        htmlString += '<div class="btn-group" style="margin-bottom: 20px;">' +
        '<a class="btn btn-mini" href="#" id="categoriesToggleHide" title="Hide all events">Hide All</a><a class="btn btn-mini" href="#" id="categoriesToggleShow" title="Show all events">Show All</a>' +
        '</div>';

        calendarsDiv.innerHTML = htmlString;

        calendarsDiv.addEventListener('click', (ev: MouseEvent) => {
            let element = ev.target as HTMLElement;

            if (element.id === "categoriesToggleHide") {
                calendarsDiv.querySelectorAll("li a").forEach((e) => {
                    let category = e.id.replace("trigger-", "");
                    self.toggleEventsinCategory(category, false);
                    e.classList.add('off')
                }) 
                return false;
            } else if (element.id === "categoriesToggleShow") {
                calendarsDiv.querySelectorAll("li a").forEach((e) => {
                    let category = e.id.replace("trigger-", "");
                    self.toggleEventsinCategory(category, true);
                    e.classList.remove('off')
                }) 
                return false;
            } 
            let idAttr = element.getAttribute("id");
            if (!idAttr) {
                throw new Error("Id attribute is null");
            }
            let category = idAttr.replace("trigger-", "");
            self.toggleEventsinCategory(category, element.classList.contains("off"));
            element.classList.toggle("off");
            return false;
            
            
        });
    }
}